/** @format */

import React from "react";
import {
  TIntermittentStatus,
  TIntermittentWorkerType,
} from "../../../../redux-modules/declarations/maps/intermittentCommunications";
import { STATUS_META } from "../constants";
import { ETICHETTA_TIPOLOGIA, TONO_STATO } from "../format";

/** Stato della comunicazione: colore di Turni e Presenze, sempre con icona e testo. */
export const PillolaStato = ({
  stato,
  etichetta,
}: {
  stato: TIntermittentStatus;
  etichetta?: string;
}): JSX.Element => {
  const meta = STATUS_META[stato];
  return (
    <span className={`pillola ${TONO_STATO[stato] || "grigio"}`}>
      {meta?.icon}
      {meta?.label || etichetta || stato}
    </span>
  );
};

/** Tipologia del dipendente (dall'anagrafica): intermittente, occasionale o entrambe. */
export const PilloleTipologia = ({
  tipologie,
  piccole = false,
}: {
  tipologie?: TIntermittentWorkerType[];
  piccole?: boolean;
}): JSX.Element | null => {
  if (!tipologie || !tipologie.length) return null;
  return (
    <>
      {tipologie.map(t => (
        <span key={t} className={`pillola ${t}${piccole ? " piccola" : ""}`}>
          {ETICHETTA_TIPOLOGIA[t]}
        </span>
      ))}
    </>
  );
};
